import React from "react";
import "antd/dist/antd.css";
import { Tag, Layout } from "antd";
import "./articleblock.css";
import QueueAnim from "rc-queue-anim";

const { Content } = Layout;

export default class ArticleBlock extends React.Component {
  render() {
    const {
      title,
      authorString,
      id,
      firstPublicationDate,
      doi,
    } = this.props.data;

    return (
      <QueueAnim
        key="demo"
        type={["right", "left"]}
        ease={["easeOutQuart", "easeInOutQuart"]}
      >
        <Content style={{ marginBottom: 15 }} className="content" key={id}>
          <div className="cardText">
            <h2
              className="head"
              onClick={
                this.props.example
                  ? null
                  : () => this.props.select(this.props.data)
              }
            >
              <a style={{ color: "#000000" }} href="#">
                {title}
              </a>
            </h2>
            <p>Авторы исследования: {authorString}</p>
            <p>Дата первой публикации {firstPublicationDate}</p>
            <div className="tagsContainer">
              <Tag>
                <span>MPID:{id}</span>
              </Tag>
              <Tag>
                <span>Doi:{doi}</span>
              </Tag>
            </div>
          </div>
        </Content>
      </QueueAnim>
    );
  }
}
